module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/102-balearic-islands-3f79d0904dc810aca8d91cc1ace4d1a2.svg";